import { Component, OnInit } from "@angular/core";
import { Scroll } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { AdminSetupService } from "../services/adminsetup.service";
import { AdjustMenuComponent } from "./adjust-menu/adjust-menu.component";
import { CalendarDayInfo } from "./CalendarDayInfo";
import { ChangeMultipleComponent } from "./change-multiple/change-multiple.component";
import { DistCalData } from "./DistCalData";
import { SetCalendarComponent } from "./set-calendar/set-calendar.component";
import * as moment from "moment";

@Component({
	selector: "app-calendarmaintenance",
	templateUrl: "./calendarmaintenance.component.html",
	styleUrls: ["./calendarmaintenance.component.css"],
})
export class CalendarmaintenanceComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private adminSetupService: AdminSetupService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	ngOnInit() {
		//
		// Make sure scroll view starts on left side of screen
		//
		var ScrollView = <HTMLElement>document.getElementsByClassName("ScrollMenu")[0]; //Get Div
		ScrollView.scrollTo(ScrollView.scrollWidth, 0); //Scroll all the way to the left

		this.user = this.userService.getCurrentUser();

		// this.loadSchoolList();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});

		////////////////////
		// Manual Calendar
		////////////////////

		//Get list of years
		this.initYearsList();

		//Get Day entries based on calendar month + data from DB
		// this.initDays();

		// this.loadDayOptions();
		// this.loadBellScheduleOptions();
		////////////////////
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	subscription: any;

	loadingSchools: any = false;
	loadingPrefs: any = false;
	loadingDayOps: any = false;
	loadingBellSchedule: any = false;
	loadingDayEntries: any = false;

	user: any;

	SchoolID: any;
	lstSchool: any = [];

	lstDayOptions: any = [];
	lstBellScheduleOptions: any = [];

	lstPref: any = [];
	CalendarTypeID: any = 0;
	SkipClosedDay: any = false;
	UseSchoolBellSchedule: any = false;

	////////////////////
	//Manual Calendar
	////////////////////
	DBData: any = [];

	Days: any = [];
	OriginalDays: any = [];

	//Date/Month that is selected
	//Default is current day
	SelectedDate: Date = new Date();

	// SelectedMonth: any = this.IntToMonth(new Date().getMonth());
	// SelectedYear: any = this.SelectedDate.getFullYear();

	DisplayMonth: any = this.IntToMonth(new Date().getMonth());
	lstMonth: any = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

	DisplayYear: any = new Date().getFullYear();
	lstYear: any = [];

	lstChangedData: any = [];

	////////////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////
	loadSchoolList() {
		this.loadingSchools = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.SchoolID = this.lstSchool[0].SchoolID;

				this.InitFullInfo();

				// //Update days on start up
				// this.initDays();
				// //Day options
				// this.loadDayOptions();
				// //Bell Schedule options
				// this.loadBellScheduleOptions();
				//Prefs
				// this.loadPreferences();

				this.loadingSchools = false;
			},
			(error) => {
				this.loadingSchools = false;
			}
		);
	}

	InitFullInfo() {
		if (this.SchoolID == undefined || this.SchoolID <= 0) {
			return;
		}

		this.loadingDayEntries = true;
		this.loadingDayOps = true;
		this.loadingBellSchedule = true;
		this.loadingPrefs = true;

		//Get Data from SP (list of selected month's days that are open or not open)
		var lstOpenValues: any = [];
		//1st of the month
		var StartDate = new Date(this.SelectedDate.getFullYear(), this.SelectedDate.getMonth(), 1);
		//Last of the month
		var EndDate = new Date(this.SelectedDate.getFullYear(), this.SelectedDate.getMonth() + 1, 0);
		var result = this.adminSetupService.GetCalendarFullInfo(moment(StartDate).format("MM/DD/YYYY"), moment(EndDate).format("MM/DD/YYYY"), this.SchoolID);
		result.subscribe(
			(response: any) => {
				var data = response;

				//
				// Day Options
				//

				this.lstDayOptions = data.lstDayOptions;
				this.lstDayOptions.unshift({
					DayID: -1,
					DayDesc: "None",
				});

				this.loadingDayOps = false;

				//
				// Bell Schedule Options
				//

				this.lstBellScheduleOptions = data.lstBellScheduleOptions;

				this.lstBellScheduleOptions.unshift({
					BellScheduleID: 0,
					BellScheduleDesc: "None",
				});

				this.loadingBellSchedule = false;

				//
				// Preferences
				//
				this.lstPref = data.lstPrefs;
				this.UpdateData();

				this.loadingPrefs = false;

				//Create days based on data
				lstOpenValues = data.lstCalendarInfo;
				this.CreateDays(lstOpenValues, false);
			},
			(error) => {}
		);
	}

	initYearsList() {
		var Today = new Date();
		var CurrentYear = Today.getFullYear();

		//Get this year + next year (Can't modify days that already happened)
		this.lstYear = [CurrentYear - 1, CurrentYear, CurrentYear + 1];

		//Could check what years are in the school year?
		//Ex. January -> June/July = year - 1, year
		//July -> December = year, year + 1
	}

	initDays(CheckSchool) {
		if (this.SchoolID == undefined || this.SchoolID <= 0) {
			return;
		}

		this.loadingDayEntries = true;

		//Get Data from SP (list of selected month's days that are open or not open)
		var lstOpenValues: any = [];

		//1st of the month
		var StartDate = new Date(this.SelectedDate.getFullYear(), this.SelectedDate.getMonth(), 1);

		//Last of the month
		var EndDate = new Date(this.SelectedDate.getFullYear(), this.SelectedDate.getMonth() + 1, 0);

		var result = this.adminSetupService.GetCalendarInfo(moment(StartDate).format("MM/DD/YYYY"), moment(EndDate).format("MM/DD/YYYY"), this.SchoolID);
		result.subscribe(
			(response) => {
				lstOpenValues = response;

				//Create days based on data
				this.CreateDays(lstOpenValues, CheckSchool);
			},
			(error) => {}
		);
	}

	CreateDays(lstOpenValues, CheckSchool) {
		//Clear data
		this.Days = [];
		this.OriginalDays = [];

		//Find Month/Day 1 Day of week
		var CurrentDate: Date = this.SelectedDate;
		CurrentDate.setDate(1);

		//Get 1st of the month's day of the week
		var StartDOW = CurrentDate.getDay() + 1; //Default is 0 based, change it to 1 based

		//Get days in the month by getting the month's last day
		var DIMDay = new Date(CurrentDate.getFullYear(), CurrentDate.getMonth() + 1, 0);
		var DaysInMonth = DIMDay.getDate();

		//Index for day of month
		var DayInd = 1;

		//Keep track of index in incomplete list
		var incompleteIndex = 0;

		//Create Days (7x5 grid so 35 days, some are blank)
		for (var i = 1; i <= 42; i++) {
			//Need separate values for current data
			//and original data (to check if data was changed)
			let nextVal: any;
			let originalVal: any;

			//Blank days
			if (i < StartDOW || DayInd > DaysInMonth) {
				nextVal = {
					CalendarID: -1,
					BellScheduleID: -1,
					SchoolID: -1,
					DayID: -1,
					CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
					Comment: "",
					DayNumber: -1,
					IsOpen: false,
					c_date: new Date(),
				};
				originalVal = {
					CalendarID: -1,
					BellScheduleID: -1,
					SchoolID: -1,
					DayID: -1,
					CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
					Comment: "",
					DayNumber: -1,
					IsOpen: false,
					c_date: new Date(),
				};
			}
			//Days w/ a Day Number
			//Use data to set open or closed
			else if (lstOpenValues.length == DaysInMonth) {
				if (lstOpenValues.length > 0 && lstOpenValues.length >= DayInd) {
					nextVal = {
						CalendarID: lstOpenValues[DayInd - 1].CalendarID,
						BellScheduleID: lstOpenValues[DayInd - 1].BellScheduleID,
						SchoolID: -1,
						DayID: lstOpenValues[DayInd - 1].DayID,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: lstOpenValues[DayInd - 1].Comment,
						DayNumber: DayInd,
						IsOpen: lstOpenValues[DayInd - 1].IsOpen == 1 ? true : false, //DayInd 1 based, array is 0 based
						c_date: lstOpenValues[DayInd - 1].c_date,
					};
					originalVal = {
						CalendarID: lstOpenValues[DayInd - 1].CalendarID,
						BellScheduleID: lstOpenValues[DayInd - 1].BellScheduleID,
						SchoolID: -1,
						DayID: lstOpenValues[DayInd - 1].DayID,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: lstOpenValues[DayInd - 1].Comment,
						DayNumber: DayInd,
						IsOpen: lstOpenValues[DayInd - 1].IsOpen == 1 ? true : false, //DayInd 1 based, array is 0 based
						c_date: lstOpenValues[DayInd - 1].c_date,
					};
				}
				//Create new entry (Value in in data set)
				else {
					nextVal = {
						CalendarID: -1,
						BellScheduleID: 0,
						SchoolID: -1,
						DayID: -1,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: "",
						DayNumber: DayInd,
						IsOpen: false,
						c_date: new Date(),
					};
					originalVal = {
						CalendarID: -1,
						BellScheduleID: 0,
						SchoolID: -1,
						DayID: -1,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: "",
						DayNumber: DayInd,
						IsOpen: false,
						c_date: new Date(),
					};
				}

				DayInd++;
			} else if (lstOpenValues.length < DaysInMonth) {
				var next: any = null;
				var DateOfNext: any = null;

				if (incompleteIndex < lstOpenValues.length) {
					//Check next entry in incomplete list
					next = lstOpenValues[incompleteIndex];
					DateOfNext = new Date(next.CalendarDate);
				}

				//Add day's value if it is the next date
				if (next != null && DateOfNext != null && DateOfNext.getDate() == DayInd && incompleteIndex < lstOpenValues.length) {
					nextVal = {
						CalendarID: lstOpenValues[incompleteIndex].CalendarID,
						BellScheduleID: lstOpenValues[incompleteIndex].BellScheduleID,
						SchoolID: -1,
						DayID: lstOpenValues[incompleteIndex].DayID,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: lstOpenValues[incompleteIndex].Comment,
						DayNumber: DayInd,
						IsOpen: lstOpenValues[incompleteIndex].IsOpen == 1 ? true : false, //DayInd 1 based, array is 0 based
						c_date: lstOpenValues[incompleteIndex].c_date,
					};
					originalVal = {
						CalendarID: lstOpenValues[incompleteIndex].CalendarID,
						BellScheduleID: lstOpenValues[incompleteIndex].BellScheduleID,
						SchoolID: -1,
						DayID: lstOpenValues[incompleteIndex].DayID,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: lstOpenValues[incompleteIndex].Comment,
						DayNumber: DayInd,
						IsOpen: lstOpenValues[incompleteIndex].IsOpen == 1 ? true : false, //DayInd 1 based, array is 0 based
						c_date: lstOpenValues[incompleteIndex].c_date,
					};

					incompleteIndex++;
				}
				//Add blank day
				else {
					nextVal = {
						CalendarID: -1,
						BellScheduleID: 0,
						SchoolID: -1,
						DayID: -1,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: "",
						DayNumber: DayInd,
						IsOpen: false,
						c_date: new Date(),
					};
					originalVal = {
						CalendarID: -1,
						BellScheduleID: 0,
						SchoolID: -1,
						DayID: -1,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: "",
						DayNumber: DayInd,
						IsOpen: false,
						c_date: new Date(),
					};
				}

				DayInd++;
			}

			//Update both lists
			this.Days = [...this.Days, nextVal];
			this.OriginalDays = [...this.OriginalDays, originalVal];
		}

		//
		// Delete last 7 entries if they are all blank
		//

		// Start Index
		var StartInd = this.Days.length - 7; //length is invalid index so -1?

		// Selected month
		var SelectedMonth = this.MonthToInt(this.DisplayMonth);

		var AllEmpty = true;

		//
		// Go through days
		//

		for (var i = StartInd; i < this.Days.length; i++) {
			var next = this.Days[i];
			// console.log(next);
			// console.log(next.CalendarDate);
			// if(next.CalendarDate.length >= 7){
			//   console.log(String(next.CalendarDate).substring(5, 7));
			//   console.log(Number(String(next.CalendarDate).substring(5, 7)));
			// }

			//
			// 0123456789
			// YYYY-MM-DD
			//
			// dString = String(next.CalendarDate);
			// nextDate = new Date(Number(dString.substring(0, 4)), Number(dString.substring(5, 7)), Number(dString.substring(8)));

			// console.log("Calendar Date");
			// console.log(nextDate);

			// console.log("Selected Month");
			// console.log(SelectedMonth);

			// console.log("Calendar Month");
			// console.log(nextDate.getMonth() );

			//
			// If day is part of current month then cancel
			//
			// NOTE: js date 0 based, and CalendarDate 1 based
			//
			if (Number(String(next.CalendarDate).substring(5, 7)) - 1 == Number(SelectedMonth)) {
				// console.log("Match");
				AllEmpty = false;
			}
		}

		//
		// Delete entries if they are empty
		//
		if (AllEmpty == true) {
			this.Days.splice(-7);
			this.OriginalDays.splice(-7);
		}

		this.loadingDayEntries = false;

		this.GetChangedData(CheckSchool);
	}

	GetChangedData(CheckSchool) {
		this.lstChangedData = [];

		for (var i = 0; i < this.Days.length; i++) {
			//Check if any of the important values changed
			if (
				this.Days[i].IsOpen != this.OriginalDays[i].IsOpen ||
				this.Days[i].DayID != this.OriginalDays[i].DayID ||
				this.Days[i].BellScheduleID != this.OriginalDays[i].BellScheduleID
			) {
				this.lstChangedData = [...this.lstChangedData, this.Days[i]];
			}
		}

		if (CheckSchool == true) {
			this.selectService.SchoolRefresh("refresh");
		}
	}

	loadPreferences() {
		this.loadingPrefs = true;

		var result = this.adminSetupService.LoadCalendarPref(this.SchoolID);
		result.subscribe(
			(response) => {
				this.lstPref = response;
				this.UpdateData();

				this.loadingPrefs = false;
			},
			(error) => {
				this.loadingPrefs = false;
			}
		);
	}

	UpdateData() {
		for (var i = 0; i < this.lstPref.length; i++) {
			var next = this.lstPref[i];

			if (next.KeyName == "CalendarDayType") {
				this.CalendarTypeID = Number(next.KeyValue);
			} else if (next.KeyName == "SkipClosedDay") {
				this.SkipClosedDay = next.KeyValue == "True" ? true : false;
			} else if (next.KeyName == "UseSchoolDayBellSchedule") {
				this.UseSchoolBellSchedule = next.KeyValue == "True" ? true : false;
			}
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolChange(val) {
		//Check if data was changed?
		this.GetChangedData(false);

		//If yes, ask if user wants to save
		if (this.lstChangedData.length > 0 && this.SchoolID != 0) {
			this.onSchoolAutoUpdate(this.lstChangedData, this.SchoolID, val); ////////////////////////////////////////
			return;
		} else {
			this.SchoolID = val;

			this.InitFullInfo();
			// //Update
			// this.initDays();
			// //Day options
			// this.loadDayOptions();
			// //Bell Schedule options
			// this.loadBellScheduleOptions();
			// //Prefs
			// this.loadPreferences();
		}
	}

	onDisplayMonthChange(val) {
		this.DisplayMonth = val;

		//Check if data was changed?
		this.GetChangedData(false);

		this.SelectedDate = new Date(this.SelectedDate.getFullYear(), this.MonthToInt(this.DisplayMonth), 1);

		//If yes, ask if user wants to save
		if (this.lstChangedData.length > 0) {
			this.onAutoUpdate(this.lstChangedData); ////////////////////////////////////////
			return;
		}

		//Load new days
		//Load new data from SP
		this.initDays(false);
		// this.InitFullInfo();
	}

	onDisplayYearChange(val) {
		this.DisplayYear = val;

		//Check if data was changed?
		this.GetChangedData(false);

		this.SelectedDate = new Date(Number(this.DisplayYear), this.SelectedDate.getMonth(), 1);

		//If yes, ask if user wants to save
		if (this.lstChangedData.length > 0) {
			this.onAutoUpdate(this.lstChangedData); ///////////////////////////////////////////////
			return;
		}

		//Load new days
		//Load new data from SP
		this.initDays(false);
	}

	onDisplayMonthYearChange(month, year) {
		this.DisplayMonth = month;
		this.DisplayYear = year;

		this.GetChangedData(false);

		this.SelectedDate = new Date(Number(this.DisplayYear), this.MonthToInt(this.DisplayMonth), 1);

		if (this.lstChangedData.length > 0) {
			this.onAutoUpdate(this.lstChangedData); ///////////////////////////////////////////////
			return;
		}

		this.initDays(false);
	}

	//Update when date is changed
	onAutoUpdate(ChangedData) {
		this.confirmationService.confirm({
			acceptLabel: "Save Changes",
			rejectLabel: "Discard Changes",
			rejectVisible: true,
			message: "Data was changed, would you like to save or discard changes?",
			header: "Data Changed",
			icon: "fa",
			//Call SP based on input
			accept: () => {
				this.ModifyCalendar(ChangedData);
			},
			reject: () => {
				this.initDays(false);
			},
		});
	}

	onSchoolAutoUpdate(ChangedData, OldSchoolID, NewSchoolID) {
		this.confirmationService.confirm({
			acceptLabel: "Save Changes",
			rejectLabel: "Discard Changes",
			rejectVisible: true,
			message: "Data was changed, would you like to save or discard changes?",
			header: "Data Changed",
			icon: "fa",
			//Call SP based on input
			accept: () => {
				this.ModifyCalendarSchool(ChangedData, OldSchoolID, NewSchoolID);
			},
			reject: () => {
				this.onReset();
				this.onSchoolChange(NewSchoolID);
			},
		});
	}

	//Update array of data when a day's checkbox is clicked
	onDayChange(val) {
		for (var i = 0; i < this.Days.length; i++) {
			var next = this.Days[i];

			if (next.DayNumber == val.DayNumber) {
				next.IsOpen = val.IsOpen;
				next.DayID = val.DayID;
				next.BellScheduleID = val.BellScheduleID;
				break;
			}
		}

		//Might get rid of, updates list of changed data
		this.GetChangedData(false);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onUpdate() {
		this.GetChangedData(false);

		if (this.lstChangedData.length == 0) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "No data was changed",
				header: "Save Data",
				icon: "fa",
				accept: () => {},
			});

			return;
		}

		this.ModifyCalendar(this.lstChangedData);
	}

	onReset() {
		for (var i = 0; i < this.Days.length; i++) {
			this.Days[i].IsOpen = this.OriginalDays[i].IsOpen;
			this.Days[i].DayID = this.OriginalDays[i].DayID;
			this.Days[i].BellScheduleID = this.OriginalDays[i].BellScheduleID;
		}

		this.lstChangedData = [];
	}

	onAdjust() {
		var ref = this.dialogService.open(AdjustMenuComponent, {
			header: "Calendar Adjustment",
			width: "fit-content",
			data: {
				SchoolID: this.SchoolID,
				UserID: this.user.userID,
				lstPref: this.lstPref,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.initDays(false);
				this.loadPreferences();
			}
		});
	}

	onTestValid() {
		var result = this.adminSetupService.TestSchoolCalendarValidity(this.SchoolID);
		result.subscribe(
			(response) => {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: String(response),
					header: "Test Results:",
					icon: "fa",
					accept: () => {},
				});
			},
			(error) => {}
		);
	}

	onChangeMultiple() {
		//Don't put "Don't change" in main menu
		//Shallow copy list
		var CMlstSchoolDay: any = [];
		for (var i = 0; i < this.lstDayOptions.length; i++) {
			CMlstSchoolDay = [...CMlstSchoolDay, this.lstDayOptions[i]];
		}

		var CMlstBellScheduleOptions: any = [];
		for (var i = 0; i < this.lstBellScheduleOptions.length; i++) {
			CMlstBellScheduleOptions = [...CMlstBellScheduleOptions, this.lstBellScheduleOptions[i]];
		}

		var ref = this.dialogService.open(ChangeMultipleComponent, {
			header: "Change Multiple Days",
			width: "fit-content",
			data: {
				SchoolID: this.SchoolID,
				lstSchoolDay: CMlstSchoolDay,
				lstBellSchedule: CMlstBellScheduleOptions,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.UpdateMultiple(response);
			}
		});
	}

	onSetSchedule() {
		//Don't put "Don't change" in main menu
		//Shallow copy list
		var CMlstSchoolDay: any = [];
		for (var i = 0; i < this.lstDayOptions.length; i++) {
			CMlstSchoolDay = [...CMlstSchoolDay, this.lstDayOptions[i]];
		}

		var CMlstBellScheduleOptions: any = [];
		for (var i = 0; i < this.lstBellScheduleOptions.length; i++) {
			CMlstBellScheduleOptions = [...CMlstBellScheduleOptions, this.lstBellScheduleOptions[i]];
		}

		var ref = this.dialogService.open(SetCalendarComponent, {
			header: "Change Schedule",
			width: "fit-content",
			data: {
				SchoolID: this.SchoolID,
				lstSchoolDay: CMlstSchoolDay,
				lstBellSchedule: CMlstBellScheduleOptions,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.InitFullInfo();
			}
		});
	}

	onNext() {
		//Get Month Index
		var MIndex = this.MonthToInt(this.DisplayMonth);
		var YIndex = 0;
		for (var i = 0; i < this.lstYear.length; i++) {
			if (this.lstYear[i] == this.DisplayYear) {
				YIndex = i;
			}
		}

		//If month is not the last in the list, increment month
		if (MIndex < this.lstMonth.length - 1) {
			this.onDisplayMonthChange(this.lstMonth[MIndex + 1]);
		}

		//Else try to go the next year (if possible)
		else {
			if (this.DisplayYear < this.lstYear[this.lstYear.length - 1]) {
				this.onDisplayMonthYearChange(this.lstMonth[0], this.lstYear[YIndex + 1]);
			}
		}
	}

	DisableNext() {
		var MIndex = this.MonthToInt(this.DisplayMonth);

		return this.DisplayYear == this.lstYear[this.lstYear.length - 1] && MIndex == this.lstMonth.length - 1;
	}

	onPrevious() {
		//Get Month Index
		var MIndex = this.MonthToInt(this.DisplayMonth);
		var YIndex = 0;
		for (var i = 0; i < this.lstYear.length; i++) {
			if (this.lstYear[i] == this.DisplayYear) {
				YIndex = i;
			}
		}

		//If month is not the last in the list, increment month
		if (MIndex > 0) {
			this.onDisplayMonthChange(this.lstMonth[MIndex - 1]);
		}

		//Else try to go the next year (if possible)
		else {
			if (this.DisplayYear > this.lstYear[0]) {
				this.onDisplayMonthYearChange(this.lstMonth[this.lstMonth.length - 1], this.lstYear[YIndex - 1]);
			}
		}
	}

	DisablePrevious() {
		var MIndex = this.MonthToInt(this.DisplayMonth);

		return this.DisplayYear == this.lstYear[0] && MIndex == 0;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	EntryEnabled(CalendarDate) {
		////User is SU (or district?)
		//var cond2 = this.user.personID == 0;

		//var nextDate = new Date(CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
		//nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

		////Or Day is <= today
		//var Today = new Date();
		//Today.setHours(0, 0, 0);

		//var cond3 = nextDate > Today;
		////var cond4 = !(nextDate < Today && nextDate > Today); //Can't use == need to check not greater and not less than
		//var cond4 = nextDate.toString() == Today.toString();

		////Disable if:
		//return cond1 && (cond2 || cond3 || cond4);

		// return false;

		return true; //Can always edit days
	}

	UpdateMultiple(Data) {
		//Change All Days
		if (Data.SelectionID == "1") {
			for (var i = 0; i < this.Days.length; i++) {
				var next = this.Days[i];

				if (next.DayNumber != -1 && this.EntryEnabled(next.CalendarDate)) {
					if (Data.SchoolDayID != -100) {
						next.DayID = Data.SchoolDayID;
					}

					if (Data.BellScheduleID != -100) {
						next.BellScheduleID = Data.BellScheduleID;
					}

					if (Data.IsOpen != "Don't Change") {
						next.IsOpen = Data.IsOpen == "Open" ? true : false;
					}
				}
			}

			this.GetChangedData(false);
		}
		//Change Weekdays
		else if (Data.SelectionID == "2") {
			for (var i = 0; i < this.Days.length; i++) {
				var next = this.Days[i];

				var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
				nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

				//Check if next is a weekday
				if (next.DayNumber != -1 && nextDate.getDay() != 0 && nextDate.getDay() != 6 && this.EntryEnabled(next.CalendarDate)) {
					if (Data.SchoolDayID != -100) {
						next.DayID = Data.SchoolDayID;
					}

					if (Data.BellScheduleID != -100) {
						next.BellScheduleID = Data.BellScheduleID;
					}

					if (Data.IsOpen != "Don't Change") {
						next.IsOpen = Data.IsOpen == "Open" ? true : false;
					}
				}
			}

			this.GetChangedData(false);
		}
		//Change Weekends
		else if (Data.SelectionID == "3") {
			for (var i = 0; i < this.Days.length; i++) {
				var next = this.Days[i];

				var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
				nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

				//Check if next is a weekday
				if (next.DayNumber != -1 && (nextDate.getDay() == 0 || nextDate.getDay() == 6) && this.EntryEnabled(next.CalendarDate)) {
					if (Data.SchoolDayID != -100) {
						next.DayID = Data.SchoolDayID;
					}

					if (Data.BellScheduleID != -100) {
						next.BellScheduleID = Data.BellScheduleID;
					}

					if (Data.IsOpen != "Don't Change") {
						next.IsOpen = Data.IsOpen == "Open" ? true : false;
					}
				}
			}

			this.GetChangedData(false);
		}
		//Change a DOW
		else if (Data.SelectionID == "4") {
			var DOWInt = this.DayToInt(Data.DOW); //Get day num from day name ex. Monday -> 1

			for (var i = 0; i < this.Days.length; i++) {
				var next = this.Days[i];

				var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
				nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

				//Check if next is a weekday
				if (next.DayNumber != -1 && nextDate.getDay() == DOWInt && this.EntryEnabled(next.CalendarDate)) {
					if (Data.SchoolDayID != -100) {
						next.DayID = Data.SchoolDayID;
					}

					if (Data.BellScheduleID != -100) {
						next.BellScheduleID = Data.BellScheduleID;
					}

					if (Data.IsOpen != "Don't Change") {
						next.IsOpen = Data.IsOpen == "Open" ? true : false;
					}
				}
			}

			this.GetChangedData(false);
		}
		//Every x days
		else if (Data.SelectionID == "5") {
			//Get Start Date Index (there might be extra entries in the list for blank days,
			//ex. July 2021 has 4 blank days in the beginning. Aug 21 doesn't have any)
			var StartDayIndex = 0;

			for (var i = 0; i < this.Days.length; i++) {
				var next = this.Days[i];
				var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
				nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

				if (nextDate.getDate() == Data.StartDay) {
					StartDayIndex = i;
					break;
				}
			}

			if (Data.SkipWeekends == false) {
				//Simple iteration w/o skipping weekends
				for (var i = StartDayIndex; i < this.Days.length; i += Data.EveryXDays) {
					var next = this.Days[i];

					//Check if it is a valid day
					if (next.DayNumber != -1 && this.EntryEnabled(next.CalendarDate)) {
						//Update
						if (Data.SchoolDayID != -100) {
							next.DayID = Data.SchoolDayID;
						}

						if (Data.BellScheduleID != -100) {
							next.BellScheduleID = Data.BellScheduleID;
						}

						if (Data.IsOpen != "Don't Change") {
							next.IsOpen = Data.IsOpen == "Open" ? true : false;
						}
					}
				}
			} else {
				//Update Start day
				var firstEntry: boolean = true;

				//Go through every day, check if day is a weekend
				var NextCount: any = 0;

				for (var i = StartDayIndex; i < this.Days.length; i++) {
					var next = this.Days[i];

					//Get date
					var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
					nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

					//If first entry
					if (firstEntry == true) {
						//Update the first valid entry
						if (next.DayNumber != -1 && nextDate.getDay() != 0 && nextDate.getDay() != 6 && this.EntryEnabled(next.CalendarDate)) {
							//Set to false
							firstEntry = false;

							//Update
							if (Data.SchoolDayID != -100) {
								next.DayID = Data.SchoolDayID;
							}

							if (Data.BellScheduleID != -100) {
								next.BellScheduleID = Data.BellScheduleID;
							}

							if (Data.IsOpen != "Don't Change") {
								next.IsOpen = Data.IsOpen == "Open" ? true : false;
							}
						}
					}
					//Else If next is a valid weekday
					if (next.DayNumber != -1 && nextDate.getDay() != 0 && nextDate.getDay() != 6 && this.EntryEnabled(next.CalendarDate)) {
						//Every x days reached
						if (NextCount == Data.EveryXDays) {
							//Update
							if (Data.SchoolDayID != -100) {
								next.DayID = Data.SchoolDayID;
							}

							if (Data.BellScheduleID != -100) {
								next.BellScheduleID = Data.BellScheduleID;
							}

							if (Data.IsOpen != "Don't Change") {
								next.IsOpen = Data.IsOpen == "Open" ? true : false;
							}

							//Reset count
							NextCount = 0;
						}

						NextCount++;
					}
				}
			}

			this.GetChangedData(false);
		}
	}

	DayToInt(str) {
		if (str == "Monday") {
			return 1;
		} else if (str == "Tuesday") {
			return 2;
		} else if (str == "Wednesday") {
			return 3;
		} else if (str == "Thursday") {
			return 4;
		} else if (str == "Friday") {
			return 5;
		} else if (str == "Saturday") {
			return 6;
		} else if (str == "Sunday") {
			return 0;
		} else {
			return -1;
		}
	}

	ModifyCalendar(Data) {
		if (this.SchoolID == undefined || this.SchoolID <= 0) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Could not update school calendar",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
		} else {
			//
			//Set up parameters
			//

			let lstCD: CalendarDayInfo[] = [];

			for (var i = 0; i < Data.length; i++) {
				var next = Data[i];

				var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
				nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

				let val1: CalendarDayInfo = {
					CalendarID: next.CalendarID,
					BellScheduleID: next.BellScheduleID,
					SchoolID: this.SchoolID,
					DayID: next.DayID,
					CalendarDate: nextDate,
					Comment: next.Comment,
					IsOpen: next.IsOpen == true ? 1 : 0,
				};

				lstCD = [...lstCD, val1];
			}

			let parms: DistCalData = {
				ApplyToAll: 0,
				UserID: this.user.userID,
				CalendarDays: lstCD,
			};

			var result = this.adminSetupService.CalendarModifyWithData(parms);

			result.subscribe(
				(response) => {
					if (response) {
						//Success
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "All changes were made successfully",
							header: "Calendar Modified",
							icon: "fa",
							accept: () => {
								this.initDays(true);
							},
						});
					} else {
						//Error
						this.confirmationService.confirm({
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could not update school calendar",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		}
	}

	ModifyCalendarSchool(Data, OldSchoolID, NewSchoolID) {
		//
		//Set up parameters
		//
		let lstCD: CalendarDayInfo[] = [];

		for (var i = 0; i < Data.length; i++) {
			var next = Data[i];

			var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> July 9th
			nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

			let val1: CalendarDayInfo = {
				CalendarID: next.CalendarID,
				BellScheduleID: next.BellScheduleID,
				SchoolID: OldSchoolID,
				DayID: next.DayID,
				CalendarDate: nextDate,
				Comment: next.Comment,
				IsOpen: next.IsOpen == true ? 1 : 0,
			};

			lstCD = [...lstCD, val1];
		}

		let parms: DistCalData = {
			ApplyToAll: 0,
			UserID: this.user.userID,
			CalendarDays: lstCD,
		};

		var result = this.adminSetupService.CalendarModifyWithData(parms);

		result.subscribe(
			(response) => {
				if (response) {
					//Success
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "All changes were made successfully",
						header: "Calendar Modified",
						icon: "fa",
						accept: () => {
							// this.initDays();

							this.SchoolID = NewSchoolID;

							this.InitFullInfo();

							// //Update
							// this.initDays();
							// //Day options
							// this.loadDayOptions();
							// //Bell Schedule options
							// this.loadBellScheduleOptions();
						},
					});
				} else {
					//Error
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update school calendar",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	//JS Month, 0 based
	IntToMonth(i) {
		if (i == 0) {
			return "January";
		} else if (i == 1) {
			return "Febuary";
		} else if (i == 2) {
			return "March";
		} else if (i == 3) {
			return "April";
		} else if (i == 4) {
			return "May";
		} else if (i == 5) {
			return "June";
		} else if (i == 6) {
			return "July";
		} else if (i == 7) {
			return "August";
		} else if (i == 8) {
			return "September";
		} else if (i == 9) {
			return "October";
		} else if (i == 10) {
			return "November";
		} else if (i == 11) {
			return "December";
		}
	}

	MonthToInt(m) {
		if (m == "January") {
			return 0;
		} else if (m == "Febuary") {
			return 1;
		} else if (m == "March") {
			return 2;
		} else if (m == "April") {
			return 3;
		} else if (m == "May") {
			return 4;
		} else if (m == "June") {
			return 5;
		} else if (m == "July") {
			return 6;
		} else if (m == "August") {
			return 7;
		} else if (m == "September") {
			return 8;
		} else if (m == "October") {
			return 9;
		} else if (m == "November") {
			return 10;
		} else if (m == "December") {
			return 11;
		}
	}

	IsToday(DayNumber) {
		var Today = new Date();

		return Today.getFullYear() == this.SelectedDate.getFullYear() && Today.getMonth() == this.SelectedDate.getMonth() && Today.getDate() == DayNumber;
	}

	////////////////////////////////////////////
}
